<template>
    <div class="account-controls">
        <!-- <button
            class="_approve"
            key="0"
            @click="toggleApproveModal()"
            :disabled="selectedAccounts.length !== 1"
        >
            Approve
        </button> -->

        <button
            class="_deny"
            key="1"
            @click="toggleConfirmReject()"
            :disabled="!selectedAccounts.length"
        >
            Reject
        </button>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
    computed: {
        ...mapFields('accountRequest', [
            'params',
            'selectedAccounts',
            'list',
            'accountForm',
            'isUpdateAccount'
        ]),

        ...mapFields('auth', [
            'user',
        ]),
        
        filterOptions () {
			return [
				{text: 'Paid', value: 'paid'},
				{text: 'Pending', value: 'pending'},
				{text: 'Late', value: 'late'},
			]
		},
    },

    methods: {
        /* Approve Account Methods */
        async toggleApproveModal () {
            const { id, country } = this.list.data.find(item => item.id === this.selectedAccounts[0])

            if (country) {
                this.getCountryZone(country)
                await this.getPartnerList(country)
            }
            
            this.isUpdateAccount = true

            this.$router.push(`/account-request/approve/${id}`)
        },

        async getPartnerList (countryName) {
            await this.$store.dispatch('global/getPartnerList', countryName)
        },

        getCountryZone (countryName) {
            this.$store.dispatch('global/getCountryZone', countryName)
        },

        /* Toggle Confirm Reject */
        toggleConfirmReject () {
            const form = new FormData()
            form.append('id', this.selectedAccounts.join(','))
            form.append('account_status', 0)

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Are you sure you want to reject this account(s)?',
                storeAction: 'accountRequest/rejectAccount',
                storePayload: form
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.account-controls {
    display: flex;
    button:not(:first-child) {
        margin-left: 10px;
    }
}
</style>